import { render, staticRenderFns } from "./CalculationItem.vue?vue&type=template&id=3ee7abb2&scoped=true"
import script from "./CalculationItem.vue?vue&type=script&lang=js"
export * from "./CalculationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee7abb2",
  null
  
)

export default component.exports